<template>
    <div>
        <van-grid>
            <van-grid-item to="/manager/funnel" icon="star-o" text="漏斗" />
            <van-grid-item to="/manager/userData" icon="star-o" text="资料完善" />
            <van-grid-item to="/manager/userIndustryReport" icon="star-o" text="行业数据" />
            <van-grid-item icon="star-o" text="行业成交" />
        </van-grid>

        <van-tabbar route>
            <van-tabbar-item replace to="/work" icon="home-o">工作台</van-tabbar-item>
            <van-tabbar-item replace to="/report" icon="chart-trending-o">报表</van-tabbar-item>
            <van-tabbar-item replace to="/manager" icon="apps-o">管理</van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {}
    },
    created() {
    },
    methods: {}
}
</script>

<style lang="scss" scoped>

</style>
